import { fetchApi } from '@/config/axiosSetting';
import { GetComplaintSummaryQueryResponseType } from './getComplaintSummaryQuery.type';

export const getComplaintSummaryFunction =
  (): Promise<GetComplaintSummaryQueryResponseType> => {
    return fetchApi.get('/survey/complaint_summary/');
  };
